var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"progressbar"}},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"progress",attrs:{"val":(_vm.val/10)+' / 10'}},[_c('div',{staticClass:"value",style:('width: '+_vm.val+'%')})])])
}
var staticRenderFns = []

export { render, staticRenderFns }